import React from 'react'

import { Navbar } from 'src/refactor/components/Navbar'

interface HeaderProps {
  onRequestContact(): void
  className?: string
}

export const Header: React.FC<HeaderProps> = ({
  onRequestContact,
  className,
}) => (
  <header className={className}>
    <Navbar onRequestContact={onRequestContact} />
  </header>
)
